'use client';

import { useState } from 'react';
import ContactModal from './ContactModal';

interface ContactButtonProps {
  className?: string;
  variant?: 'header' | 'hero' | 'cta';
}

export default function ContactButton({ className = '', variant = 'header' }: ContactButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseStyles = {
    header: 'bg-brand-black text-white px-6 py-3 font-bold hover:bg-opacity-90 transition uppercase',
    hero: 'inline-block bg-brand-black text-white px-8 py-4 font-bold hover:bg-opacity-90 transition uppercase',
    cta: 'inline-block bg-brand-black text-white px-8 py-4 font-bold hover:bg-opacity-90 transition uppercase'
  };

  return (
    <>
      {/* Mobile: Click to Call */}
      <a
        href="tel:17187488888"
        className={`lg:hidden ${baseStyles[variant]} ${className}`}
      >
        CALL (718) 748-8888
      </a>

      {/* Desktop/Tablet: Contact Us button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className={`hidden lg:block ${baseStyles[variant]} ${className}`}
      >
        CONTACT US
      </button>

      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
